import { captureMessage } from '@/lib/errors';

export type GetImageDimensions = Awaited<ReturnType<typeof getImageDimensions>>;
// 这个写法有问题的吧 ,每次要多拿一遍
export const getImageDimensions = async (
  imgUrl: string,
): Promise<{ height: number; width: number }> => {
  const img = new Image();
  img.src = imgUrl;

  return new Promise((resolve, reject) => {
    img.onload = (evt) => {
      const target = evt.target as HTMLImageElement;
      resolve({ width: target.width, height: target.height });
    };

    img.onerror = (error) => {
      captureMessage('Failed to calculate image dimensions', {
        tags: {
          image: true,
        },
        extra: {
          src: imgUrl,
        },
      });
      reject(error);
    };
  });
};
